module.exports = __webpack_public_path__ + "static/media/placeholder.d993d7b3.png";